// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"b16647fe","213":"537ddf04","864":"91c6c253"}[chunkId] + ".chunk.css";
};